import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material'

import { SettingsDropdown } from 'src/components'
import { ETranslationNs, EUserProviders } from 'src/types'
import { ProviderIcon } from 'src/assets/icons/v2/ProviderIcon'
import { LoginProvidersModal } from './login-providers-modal.component'
import { useGetUserProviders } from 'src/hooks'
import { useTLoginTypes } from 'src/hooks/login-types/use-login-types.hook'

const LoginProvidersButton = () => {
  const [t] = useTranslation(ETranslationNs.UserProfile)
  const [open, setOpen] = useState(false)

  const theme = useTheme()

  const { data: loginTypePermissions, isLoading: isLoginTypePermissionsLoading } = useTLoginTypes()
  const { data: providers, isLoading } = useGetUserProviders()

  const handleClose = () => setOpen(false)
  const handleChangePassword = () => setOpen(true)

  const showConnectToXButton = !providers?.some(
    (provider) => provider?.provider === EUserProviders.X,
  )

  const filteredProviders = useMemo(() => {
    if (!providers || !loginTypePermissions || !loginTypePermissions.data) {
      return []
    }
    return providers.filter((provider) =>
      loginTypePermissions.data.some(
        (loginType) => loginType.active && loginType.name === provider.provider,
      ),
    )
  }, [providers, loginTypePermissions])

  const disabled = !(filteredProviders && filteredProviders?.length > 0)

  return (
    <>
      <SettingsDropdown
        onButtonClick={handleChangePassword}
        text={t('user-profile-security-login-providers-button-label.v', {
          ns: ETranslationNs.UserProfile,
        })}
        icon={
          <ProviderIcon
            color={disabled ? theme.palette.custom.grey2 : theme.palette.custom.darkBlue2}
          />
        }
        disabled={disabled}
      />
      <LoginProvidersModal
        open={open}
        onClose={handleClose}
        providers={filteredProviders}
        isLoading={isLoading || isLoginTypePermissionsLoading}
        showConnectToXButton={showConnectToXButton}
      />
    </>
  )
}

export { LoginProvidersButton }
